
// CookieOverlay.js
import React from 'react';
//import DOMPurify from 'dompurify';


const CookieOverlay = () => (
	<>
		{/* OneTrust Cookies List start */}
			<div id="optanon-cookie-policy"></div>
		{/* OneTrust Cookies List end */}
	</>
);

export default CookieOverlay;


